import { Footer } from 'components/Footer'
import { Layout } from 'components/Layout'
import React, { ReactNode } from 'react'
import { MealPlanHeader } from '../MealPlanHeader'
import { ContentWrapper, MaxSize, MealPlanRoot } from './MealPlanLayout.styles'
import { Header } from 'components/Header'

export const MealPlanLayout: React.FC<{
  children?: ReactNode
  step?: number
  step4premade?: boolean
}> = ({ children, step, step4premade }) => {
 const header = <Header trimmed />

 return (
    <MealPlanRoot>
      <Layout header={header} hideCTA={true}>
        <MealPlanHeader />
        <ContentWrapper>
          <MaxSize>{children}</MaxSize>
        </ContentWrapper>
        <Footer background="tertiary-200" />
      </Layout>
    </MealPlanRoot>
  )
}

MealPlanLayout.displayName = 'MealPlan'
